import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivitylogComponent } from './activitylog.component';
import { FormsModule } from '@angular/forms';
import { UnderscoreToSpaceModule } from 'src/app/shared/pipes/underscore-to-space.pipe';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  declarations: [ActivitylogComponent],
  imports: [
    CommonModule,
    FormsModule,
    UnderscoreToSpaceModule,
    NgbAccordionModule
  ],
  exports:[ActivitylogComponent]
})
export class ActivitylogModule { }
